import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { getDocsPath } from "../../utils/docUtils/docsRouteUtils";
import prevNextStyles from "../../styles/docs/docsPrevNext.module.scss";

const DocsPrevNext = ({ docNav, prev, next }) => (
  <div className={prevNextStyles.row}>
    {prev ? (
      <Link
        to={getDocsPath(docNav, prev.id)}
        className={prevNextStyles.link}
      >
        <ChevronRight size={14} className={prevNextStyles.iconPrev} />
        <span>{prev.label}</span>
      </Link>
    ) : (
      <div className={prevNextStyles.spacer} />
    )}
    {next ? (
      <Link
        to={getDocsPath(docNav, next.id)}
        className={`${prevNextStyles.link} ${prevNextStyles.linkNext}`}
      >
        <span>{next.label}</span>
        <ChevronRight size={14} className={prevNextStyles.iconNext} />
      </Link>
    ) : (
      <div className={prevNextStyles.spacer} />
    )}
  </div>
);

export default DocsPrevNext;
